import { CommandType } from "~app/common/services/cqs/CommandType";
import { AvverkningsanmalanCommandBase } from "./AvverkningsanmalanCommandBase";

export class CreateAvverkningsanmalanCommand extends AvverkningsanmalanCommandBase {
// eslint-disable-next-line sonarjs/public-static-readonly
    static typeName = "CreateAvverkningsanmalanCommand";

    constructor(kontraktGuid: string, atgardGuid: string) {
        super(kontraktGuid, atgardGuid, CreateAvverkningsanmalanCommand.typeName, CommandType.Insert);
    }
}
